<template>
  <div class="contents">
      <div class="crm">
        <div class="title">完善CRM模块</div>
        <div class="write">
            无论是游客还是会员，支持多种筛选条件，助你精准定位、了解核心用户
        </div>
        <div class="port">
            <img src="./images/phone1.png" alt="手机" oncontextmenu="return false;" onselectstart="return false;">
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'crm',
}
</script>

<style scoped>
.contents{
    width:100%;
    /* height: 100%; */
    height: 1080px;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.crm{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* overflow: hidden; */
}
.title{
    font-family: 微软雅黑;
font-size: 50px;
line-height: 0px;
letter-spacing: 5px;
height: 50px;
line-height: 50px;
margin-top:100px;
color: #333333;
}
.write{
height: 66px;
font-family: 微软雅黑;
font-size: 24px;
letter-spacing: 1px;
color: #999999;
margin-top:50px;
text-align: center;
}
.port{
width: 1094px;
height: 756px;
margin-top:73px;
}
/* @media screen and (max-height:800px){
    .crm{
        transform: scale(0.6);
    }
    .contents{
        height: 100vh;
    }
} */
@media screen and (max-width:1150px){
    .port{
        transform: scale(0.8);
    }
}
</style>




// WEBPACK FOOTER //
// src/components/software/crm.vue